import { Interpolation } from "@emotion/core";
import { Device, DarkTheme } from "../../design-tokens/media-queries";
import { Border } from "../../design-tokens/borders";
import { grid } from "../../design-tokens/grid";
import { Colors } from "../../design-tokens/colors";
import LoadingIcon from "../../../images/loading.svg";

const imageContainer: Interpolation = {
  background: `url(${LoadingIcon}) no-repeat center`,
  backgroundColor: Colors.LightGrey,
  marginBottom: grid(3),
  overflow: "hidden",

  [Device.DesktopTablet]: {
    borderRadius: Border.RadiusSm,
  },

  "> img": {
    width: "100%",

    [DarkTheme]: {
      backgroundColor: Colors.White,
      padding: grid(1),
    },
  },
};

const content: Interpolation = {
  fontSize: "14px",
  marginBottom: grid(3),

  [Device.DesktopTablet]: {
    marginBottom: grid(4),
  },

  "> *:last-child": {
    marginBottom: "0 !important",
  },
};

const styles = {
  imageContainer,
  content,
};

export default styles;
